import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { PersonGenderService } from '../../../../../../services/person-genders/person-gender.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { Observable } from 'rxjs/Observable';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { AddEmployeeDto, JobTitleData } from '../../../../../../models/employee/add-employee-dto';
import { EmployeeService } from '../../../../../../services/employee/employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { MY_FORMATS } from '../../../../../../const/date-format';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { RelationshipService } from '../../../../../../services/relationships/relationship.service';


@Component({
    selector: 'fuse-add-employee',
    templateUrl: './add-employee.component.html',
    styleUrls: ['./add-employee.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class FuseAddorEditEmployeeComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    formGroup;

    docNumberFormControl;
    lastNameFormControl;
    firstNameFormControl;
    aliasFormControl;
    birthdateFormControl;
    genderFormControl;
    cuilFormControl;
    phoneNumberFormControl;
    mobilePhoneNumberFormControl;
    anotherContactPhoneFormControl;
    emailFormControl;
    addressFormControl;
    hireDateFormControl;
    teachingStarDateFormControl;
    titleFormControl;
    posttitleFormControl;
    postGraduateCourseFormControl;
    otherTrainingsFormControl;
    relationshipFormControl;
    emergencyContactFormControl;
    phoneNumberEmergencyContactFormControl;

    // cargos form
    formGroupCargos;

    public baseUri;

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    /*public mask = {
        guide: true,
        showMask: true,
        mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    };*/
    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerBirthdate;
    maskedInputControllerTeachingstartdate;
    maskedInputControllerHiredate;
    @ViewChild('birthdate', {read: ViewContainerRef}) public birthdate;
    @ViewChild('teachingstartdate', {read: ViewContainerRef}) public teachingstartdate;
    @ViewChild('hiredate', {read: ViewContainerRef}) public hiredate;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseAddorEditEmployeeComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private employeeService: EmployeeService,
        private fb: FormBuilder,
        public personGenderService: PersonGenderService,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private relationshipService: RelationshipService,
    ) {
        console.log('FuseAddStudentComponent > data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        Observable.combineLatest(
            this.personGenderService.getAll(),
            this.typeEmployeeService.getAll(),
            this.jobTitleService.getAll(),
            this.shiftService.getAll(),
            this.relationshipService.getAll()
        ).subscribe(([personGenders, typeEmployees, jobTitles, shifts, relationships]) => {
            console.log('jobTitles>>>>>>>', jobTitles);
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.formGroup.get('docNumberFormControl').disable();
        this.formGroup.get('cuilFormControl').disable();
        this.formGroup.get('lastNameFormControl').disable();
        this.formGroup.get('firstNameFormControl').disable();
        this.formGroup.get('aliasFormControl').disable();
        this.formGroup.get('birthdateFormControl').disable();
        this.formGroup.get('genderFormControl').disable();
        this.formGroup.get('phoneNumberFormControl').disable();
        this.formGroup.get('mobilePhoneNumberFormControl').disable();
        this.formGroup.get('anotherContactPhoneFormControl').disable();
        this.formGroup.get('emailFormControl').disable();
        this.formGroup.get('addressFormControl').disable();
        this.formGroup.get('hireDateFormControl').disable();
        this.formGroup.get('teachingStarDateFormControl').disable();
        this.formGroup.get('titleFormControl').disable();
        this.formGroup.get('posttitleFormControl').disable();
        this.formGroup.get('postGraduateCourseFormControl').disable();
        this.formGroup.get('otherTrainingsFormControl').disable();
        this.formGroup.get('relationshipFormControl').disable();
        this.formGroup.get('emergencyContactFormControl').disable();
        this.formGroup.get('phoneNumberEmergencyContactFormControl').disable();
        
    }

    ngOnDestroy() {
        this.maskedInputControllerBirthdate.destroy();
        this.maskedInputControllerTeachingstartdate.destroy();
        this.maskedInputControllerHiredate.destroy();
    }


    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerBirthdate = textMask.maskInput({
                inputElement: this.birthdate.element.nativeElement,
                mask: this.mask
            });

            this.maskedInputControllerTeachingstartdate = textMask.maskInput({
                inputElement: this.teachingstartdate.element.nativeElement,
                mask: this.mask
            });

            this.maskedInputControllerHiredate = textMask.maskInput({
                inputElement: this.hiredate.element.nativeElement,
                mask: this.mask
            });
        });
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            docNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            cuilFormControl: ['', [Validators.required, Validators.maxLength(15)]],
            lastNameFormControl: ['', [Validators.required]],
            firstNameFormControl: ['', [Validators.required]],
            aliasFormControl: ['', []],
            birthdateFormControl: ['', [Validators.required]],
            genderFormControl: ['', [Validators.required]],

            phoneNumberFormControl: ['', []],
            mobilePhoneNumberFormControl: ['', []],
            anotherContactPhoneFormControl: ['', []],
            emailFormControl: ['', []],
            addressFormControl: ['', []],
            hireDateFormControl: ['', []],
            teachingStarDateFormControl: ['', []],
            titleFormControl: ['', []],
            posttitleFormControl: ['', []],
            postGraduateCourseFormControl: ['', []],
            otherTrainingsFormControl: ['', []],
            relationshipFormControl: ['', []],
            emergencyContactFormControl: ['', []],
            phoneNumberEmergencyContactFormControl: ['', []],
            
        });
        this.formGroupCargos = this.fb.group({});
    }

    checkValidationErrors() {
        if (this.data.mode === 'new') {
            const lastName = (this.data.employee.LastName || '').trim();
            const firstName = (this.data.employee.FirstName || '').trim();
            this.data.employee.Alias = lastName + (lastName && firstName ? ', ' : '') + firstName;
        }
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            this.addEmployee();
        } else {
            this.editEmployee();
        }
    }

    addEmployee() {
        this.blockUI.start(this.translationService.savingChanges);
        const addEmployeeDto = new AddEmployeeDto();

        addEmployeeDto.Id = this.data.employee.Id;
        addEmployeeDto.DocumentNumber = this.data.employee.DocumentNumber;
        addEmployeeDto.CUIL = this.data.employee.CUIL;
        addEmployeeDto.FirstName = this.data.employee.FirstName;
        addEmployeeDto.LastName = this.data.employee.LastName;
        addEmployeeDto.Alias = this.data.employee.Alias;
        addEmployeeDto.Birthdate = this.data.employee.Birthdate;
        addEmployeeDto.PersonGenderId = this.data.employee.PersonGenderId;
        addEmployeeDto.PhoneNumber = this.data.employee.PhoneNumber;
        addEmployeeDto.MobilePhoneNumber = this.data.employee.MobilePhoneNumber;
        addEmployeeDto.AnotherContactPhone = this.data.employee.AnotherContactPhone;
        addEmployeeDto.Address = this.data.employee.Address;
        addEmployeeDto.Email = this.data.employee.Email;
        addEmployeeDto.JobTitles = this.data.employee.JobTitles;

        addEmployeeDto.Title = this.data.employee.Title;
        addEmployeeDto.PostTitle = this.data.employee.PostTitle;
        addEmployeeDto.PostGraduateCourse = this.data.employee.PostGraduateCourse;
        addEmployeeDto.OtherTrainings = this.data.employee.OtherTrainings;
        addEmployeeDto.HireDate = this.data.employee.HireDate;
        addEmployeeDto.TeachingStarDate = this.data.employee.TeachingStarDate;
        addEmployeeDto.RelationshipId = this.data.employee.RelationshipId;
        addEmployeeDto.EmergencyContact = this.data.employee.EmergencyContact;
        addEmployeeDto.PhoneNumberEmergencyContact = this.data.employee.PhoneNumberEmergencyContact;
        

        this.employeeService.add(addEmployeeDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.employee.Id = response.Id;
                this.employeeService.employees.push(this.data.employee);
                this.employeeService.employeesObject[this.data.employee.Id] = this.data.employee;
                this.dialogRef.close(this.data.employee);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.person, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }

    editEmployee() {
        this.blockUI.start(this.translationService.savingChanges);

        const addEmployeeDto = new AddEmployeeDto();

        addEmployeeDto.Id = this.data.employee.Id;
        addEmployeeDto.DocumentNumber = this.data.employee.DocumentNumber;
        addEmployeeDto.CUIL = this.data.employee.CUIL;
        addEmployeeDto.FirstName = this.data.employee.FirstName;
        addEmployeeDto.LastName = this.data.employee.LastName;
        addEmployeeDto.Alias = this.data.employee.Alias;
        addEmployeeDto.Birthdate = this.data.employee.Birthdate;
        addEmployeeDto.PersonGenderId = this.data.employee.PersonGenderId;
        addEmployeeDto.PhoneNumber = this.data.employee.PhoneNumber;
        addEmployeeDto.MobilePhoneNumber = this.data.employee.MobilePhoneNumber;
        addEmployeeDto.AnotherContactPhone = this.data.employee.AnotherContactPhone;
        addEmployeeDto.Address = this.data.employee.Address;
        addEmployeeDto.Email = this.data.employee.Email;
        addEmployeeDto.JobTitles = this.data.employee.JobTitles;

        addEmployeeDto.Title = this.data.employee.Title;
        addEmployeeDto.PostTitle = this.data.employee.PostTitle;
        addEmployeeDto.PostGraduateCourse = this.data.employee.PostGraduateCourse;
        addEmployeeDto.OtherTrainings = this.data.employee.OtherTrainings;
        addEmployeeDto.HireDate = this.data.employee.HireDate;
        addEmployeeDto.TeachingStarDate = this.data.employee.TeachingStarDate;
        addEmployeeDto.RelationshipId = this.data.employee.RelationshipId;
        addEmployeeDto.EmergencyContact = this.data.employee.EmergencyContact;
        addEmployeeDto.PhoneNumberEmergencyContact = this.data.employee.PhoneNumberEmergencyContact;

        this.employeeService.edit(addEmployeeDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.employeeService.employees.findIndex(st => st.Id === this.data.employee.Id);
                console.log('valor index', index);
                console.log(this.employeeService.employees[index]);
                this.employeeService.employees[index] = this.data.employee;
                this.employeeService.employeesObject[this.data.employee.Id] = this.data.employee;
                this.dialogRef.close(this.data.employee);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.person, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    getAge(birthdate: Date) {
        const momentNow = moment();
        const momentBirthdate = moment(birthdate);
        const diffDuration = moment.duration(momentNow.diff(momentBirthdate));
        let age = '';
        if (!!diffDuration.years() && diffDuration.years() > 0) {
            age += diffDuration.years().toString() + (diffDuration.years() === 1 ? ' año' : ' años');
        }
        if (!!diffDuration.months() && diffDuration.months() > 0) {
            // tslint:disable-next-line:max-line-length
            // age += age == '' ? diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses'));
            if ((momentBirthdate.month() === momentNow.month()) && (momentNow.date() <= momentBirthdate.date())) {
                age = (diffDuration.years() + 1).toString() + ((diffDuration.years() + 1) === 1 ? ' año' : ' años');
            } else {
                // tslint:disable-next-line:max-line-length
                age += age === '' ? diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses'));
            }
        }
        return age;
    }

    addJobTitle() {
        this.data.employee.JobTitles.push(new JobTitleData());
    }

    onBlurDocumentNumber() {
        if (!this.data.employee.DocumentNumber) {
            return;
        }
        this.blockUI.start('buscando');
        this.employeeService.getByDocumentNumber(this.data.employee.DocumentNumber).subscribe(e => {
            console.log(e);
            if (e) {
                this.data.employee = e;
            }
            this.blockUI.stop();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/add-employee/add-employee.component.ts